/* eslint-disable complexity */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Zoom from "./images/zoom.svg";
import {TransformWrapper, TransformComponent} from "react-zoom-pan-pinch";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import { NUMBER } from "../../../constants/app-constants";

const CONFIG = {
    SCALE: 1.2,
    X: -216,
    Y: -162,
    MAX_SCALE: 2,
    WRAPPER_CLASS: "imageWrapperBound",
    TIMER: 2000
};

const CarGalleryImageViewer = ({
    selectedImage,
    basePath,
    transformProps = null,
    styleProp = "",
    showPinchLabel = true,
    altText,
    ...rest
}) => {
    const {
        path,
        label
    } = selectedImage || {};
    const imageAlt = altText ? `${altText}, ${label || ""}`.trim() : (label || "Car image");

    const [showPinch, setShowPinch] = useState(showPinchLabel);
    const [dblClicked, setDblClicked] = useState(false);
    const imageUrl = fastlyUrl(
        basePath,
        path,
        imageTypes.spinCarZoomable);

    const hideShowPinch = () => {
        const timeout = window.setTimeout(() => setShowPinch(false), CONFIG.TIMER);
        return () => window.clearTimeout(timeout);
    };

    const handleDoubleClick = () => {
        setDblClicked(!dblClicked);
        setShowPinch(true);
        // hideShowPinch();
    };
    const timerRef = useRef(null);

    const handleClick = () => {
        if (!timerRef.current) {
            timerRef.current = window.setTimeout(() => {
                timerRef.current = null;
            }, NUMBER.TWO_HUNDRED);
        } else {
            handleDoubleClick();
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };

    useEffect(() => {
        // eslint-disable-next-line no-magic-numbers
        hideShowPinch();
    }, []);

    useEffect(() => {
        if (path) {
            setDblClicked(false);
        }
    }, [path]);

    const handlePinch = (ref) => {
        const { scale, previousScale } = ref && ref.state;
        if (!dblClicked && ref && scale > 1) {
            setDblClicked(true);
        } else if (dblClicked && scale  <= 1 && previousScale <= 1) {
            setDblClicked(false);
        }
    };
    const trasformWrapperProps = transformProps || {
        initialScale: dblClicked ? CONFIG.SCALE : NUMBER.ONE,
        defaultScale: NUMBER.ONE,
        positionX: dblClicked ? CONFIG.X : NUMBER.ZERO,
        positionY: dblClicked ? CONFIG.Y : NUMBER.ZERO,
        maxScale: CONFIG.MAX_SCALE,
        panning: {
            disabled: true
        },
        doubleClick: {
            disabled: true
        },
        options: {
            wrapperClass: CONFIG.WRAPPER_CLASS
        },
        wrapperClass: CONFIG.WRAPPER_CLASS,
        limitToBounds: true,
        onZoomStop: handlePinch,
        pinch: {step: 0.3},
        centerOnInit: true,
        ...rest
    };
    return (
        <React.Fragment>
            {/* {!dblClicked && <div styleName={"styles.imageWrapper"} onClick={handleClick}>
                <img src={imageUrl} styleName={"styles.carImage"} />
            </div>} */}
            { <div
                styleName={dblClicked ? "styles.imageWrapperOverFlow" : `styles.imageWrapper ${styleProp ? `styles.${styleProp}` : ""}`}>
                <TransformWrapper
                    {...trasformWrapperProps}
                >
                    {/* {({ centerView, ...rest }) => ( */}

                    <div styleName={"styles.showcaseWrap"}>
                        <TransformComponent>
                            <img src={imageUrl} styleName={"styles.carImage"} onClick={handleClick} alt={imageAlt} />
                        </TransformComponent>
                    </div>
                    {/* )} */}
                </TransformWrapper>
                {/* <img src={Image} styleName={"styles.carImage"} alt="Car Detail" /> */}
                {showPinch && <p styleName={"styles.pinchText"}>
                    <img src={Zoom} alt="zoom image" />
                    {dblClicked ? "Double tap to zoom out" : "Pinch to Zoom"}
                </p> }
            </div>}

            {/* <TransformWrapper
                initialScale={0}
                initialPositionX={0}
                initialPositionY={0}
            >
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <React.Fragment>
                        <div className="tools">
                            <button onClick={() => zoomIn()}>+</button>
                            <button onClick={() => zoomOut()}>-</button>
                            <button onClick={() => resetTransform()}>x</button>
                        </div>
                        <TransformComponent>
                            <img src={imageUrl} alt="test" />
                            <div>Example text</div>
                        </TransformComponent>
                    </React.Fragment>
                )}
            </TransformWrapper> */}
        </React.Fragment>
    );
};

CarGalleryImageViewer.propTypes = {
    selectedImage: PropTypes.object,
    baseUrl: PropTypes.string,
    transformProps: PropTypes.object,
    size: PropTypes.string,
    styleProp: PropTypes.string,
    panningDisabled: PropTypes.bool,
    basePath: PropTypes.string,
    showPinchLabel: PropTypes.bool,
    altText: PropTypes.string
};

export default React.memo(CarGalleryImageViewer);
